/* Dependencies
 ----------------------------------------------------------*/
import {Application} from "wrapper6";

/* Vendor
 ----------------------------------------------------------*/


/* Setup
 ----------------------------------------------------------*/
var app = window.app = new Application(window.options || {});

/* Services
 ----------------------------------------------------------*/


/* Register services
 ----------------------------------------------------------*/

/* Modules
 ----------------------------------------------------------*/
import Navigation from "modules/_navigation.js";
import ObjectFit from "modules/_object-fit.js";
import Print from "modules/_print.js";
import HoverEffect from "modules/_hover-effect";
import FrontpageSlider from "modules/_frontpage-slider";
import LazyLoad from "modules/_lazy-load";
import Instafeed from "modules/_insta-feed";
import NewsCover from "modules/_news-cover";
import VideoSlider from "modules/_video-slider";
import VideoModal from "modules/_video-modal";
import PostSliders from "modules/_post-sliders";
import Search from "./widgets/_search";
import MapWidget from "./widget/_map-widget";
import CampaignSlider from "modules/_campaign-slider";
import Sticky from "modules/_sticky";
import SocialShare from "modules/_social-share";
import NavSearch from "modules/_nav-search";
import ItemWall from "modules/_item-wall";
import EmployeeSlider from "modules/_employee-slider";
import SmoothScroll from "modules/_smooth-scroll";
import MTTModal from "modules/_mtt-modal";
import DownloadVideo from "modules/_download-video";
import MaterialSearch from "./modules/_search";
import Archive from "./modules/_archive";
import Donation from "./modules/_donation";


/* Register modules
 ----------------------------------------------------------*/
app.use(Navigation);
app.use(ObjectFit);
app.use(Print);
app.use(HoverEffect);
app.use(FrontpageSlider);
app.use(LazyLoad);
app.use(Instafeed);
app.use(NewsCover);
app.use(VideoSlider);
app.use(VideoModal);
app.use(PostSliders);
app.use(Search);
app.use(MapWidget);
app.use(CampaignSlider);
app.use(Sticky);
app.use(SocialShare);
app.use(NavSearch);
app.use(ItemWall);
app.use(EmployeeSlider);
app.use(SmoothScroll);
app.use(MTTModal);
app.use(DownloadVideo);
app.use(MaterialSearch);
app.use(Archive);
app.use(Donation);

require('./app');
